export function formatOrderDatePart(date: Date | string = new Date()): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = String(d.getFullYear()).slice(-2);
  return `${day}${month}${year}`;
}

export function formatOrderRef(
  orderId: number | string,
  date: Date | string = new Date()
): string {
  return `ORD-${formatOrderDatePart(date)}-${orderId}`;
}

export function formatOrderDisplayRef(
  orderId: number | string,
  date: Date | string = new Date()
): string {
  return `#${formatOrderRef(orderId, date)}`;
}
